import Cookies from 'js-cookie'

const state = {
  language: localStorage.getItem('language') || 'en',
  historyList: [],
  size: Cookies.get('size') || 'medium',
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
  },
}

const mutations = {
  SET_LANGUAGE: (state, language) => {
    state.language = language
    Cookies.set('language', language)
  },
  SET_SIZE: (state, size) => {
    state.size = size
    Cookies.set('size', size)
  },
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1)
    } else {
      Cookies.set('sidebarStatus', 0)
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0)
    state.sidebar.opened = false
  },
  SET_HISLIST: (state, historyList) => {
    state.historyList = historyList
    Cookies.set('historyList', historyList)
  },
  DEL_HISLIST: (state, activeName) => {
    state.historyList.map((v,i)=> {
      if(v.url == activeName){
         state.historyList.splice(i,1)
      }
    })
  }
}

const actions = {
  setLanguage({ commit }, language) {
    commit('SET_LANGUAGE', language)
  },
  setSize({ commit }, size) {
    commit('SET_SIZE', size)
  },
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  setHisList({ commit }, historyList) {
    commit('SET_HISLIST', historyList)
  },
  delItem({commit},activeName) {
    commit('DEL_HISLIST',activeName)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
